<template>
  <div>
    <ValidationObserver ref="form">
      <div class="row mb-3">
        <div class="col-md-4">
          <validation-provider v-slot="{ errors }" rules="required">
            <vue-select
              :options="estabelecimentos"
              label="no_unidade_saude"
              placeholder="Unidade de saúde"
              v-model="form.co_ubs"
              :loading="loadingEstabelecimentos"
              :disabled="loadingEstabelecimentos"
            >
              <template slot="option" slot-scope="option">
                {{ option.no_unidade_saude }}
              </template>
              <div slot="no-options">Não há opções correspondentes</div>
            </vue-select>
            <div class="error">{{ errors[0] }}</div>
          </validation-provider>
        </div>
        <div class="col-md-3">
          <validation-provider v-slot="{ errors }" rules="required">
            <vue-select
              :options="monthOptions"
              label="label"
              placeholder="Mês"
              v-model="form.mes"
              :clearable="false"
            >
              <template slot="option" slot-scope="option">
                {{ option.label }}
              </template>
              <div slot="no-options">Não há opções correspondentes</div>
            </vue-select>
            <div class="error">{{ errors[0] }}</div>
          </validation-provider>
        </div>
        <div class="col-md-2">
          <validation-provider
            v-slot="{ errors }"
            rules="required|onlyNumbers|ano"
          >
            <input
              type="text"
              class="form-control"
              placeholder="Ano"
              v-model="form.ano"
              v-inputmask="maskNumbers"
              maxlength="4"
            />
            <div class="error">{{ errors[0] }}</div>
          </validation-provider>
        </div>
        <div class="col-md-3">
          <validation-provider v-slot="{ errors }">
            <vue-select
              :options="typeOptions"
              label="label"
              placeholder="Tipo"
              v-model="form.tipo"
              :clearable="true"
            >
              <template slot="option" slot-scope="option">
                {{ option.label }}
              </template>
              <div slot="no-options">Não há opções correspondentes</div>
            </vue-select>
            <div class="error">{{ errors[0] }}</div>
          </validation-provider>
        </div>
        <div class="col-md-2">
          <button class="btn mt-3" @click="buscar()">Buscar</button>
        </div>
      </div>
    </ValidationObserver>
    <div class="row">
      <div class="col-md-12">
        <div class="info-table">
          <div class="info-table-item"></div>
          <div class="info-table-item">
            <download-files
              :callback-pdf="generatePdf"
              :data="cadastrosParaXls"
              :fields="dataFields"
              name="bpac"
            >
            </download-files>
          </div>
        </div>
        <tabela-cadastros
          ref="table"
          :cadastros="displayedCadastros"
          :loading="loading"
          @filterSearch="filterSearch($event)"
        ></tabela-cadastros>
      </div>
    </div>
  </div>
</template>

<script>
import * as Functions from './functions.js'
import utils from '@/mixins/utils.js'
import TabelaCadastros from './TabelaCadastros.vue'
import Selects from '@/components/utils/Selects.vue'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { validations } from '@/mixins/validations'
validations()
import Masks from '@/mixins/masks'
import { dataFields } from './utils.js'

export default {
  name: 'BPAC',
  components: {
    TabelaCadastros,
    Selects,
    DownloadFiles,
    ValidationObserver,
    ValidationProvider,
  },
  mixins: [utils],
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      return this.cadastros
    },
    cadastrosParaXls() {
      return this.displayedCadastros.map((item, index) => ({
        sequencia: index + 1,
        ...item,
      }))
    },
    maskNumbers() {
      return Masks['number']
    },
  },
  data() {
    return {
      equipe: '',
      cadastros: [],
      totalItems: 0,
      loading: false,
      equipName: '',
      monthOptions: [
        { label: 'Janeiro', value: '01' },
        { label: 'Fevereiro', value: '02' },
        { label: 'Março', value: '03' },
        { label: 'Abril', value: '04' },
        { label: 'Maio', value: '05' },
        { label: 'Junho', value: '06' },
        { label: 'Julho', value: '07' },
        { label: 'Agosto', value: '08' },
        { label: 'Setembro', value: '09' },
        { label: 'Outubro', value: '10' },
        { label: 'Novembro', value: '11' },
        { label: 'Dezembro', value: '12' },
      ],
      month: '',
      disabledMonth: true,
      cadastrosOriginais: [],
      filterSearchTable: false,
      form: {
        co_ubs: null,
        mes: '',
        ano: '',
        tipo: {
          label: 'Exclusivamente BPA C',
          value: 'bpac',
        },
      },
      dataFields: {
        ...dataFields,
      },
      loadingEstabelecimentos: false,
      estabelecimentos: [],
      typeOptions: [
        {
          label: 'Exclusivamente BPA C',
          value: 'bpac',
        },
        {
          label: 'BPA C ou BPA I',
          value: 'bpac-ou-bpai',
        },
      ],
    }
  },
  methods: {
    /**
     * Atualiza o estado do filtro de busca da tabela.
     * @param {Object} item Item selecionado
     */
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },

    /**
     * Retorna o mês atual
     *
     * @returns {String}
     */
    getCurrentMonth() {
      const date = new Date()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      return month
    },

    /**
     * Carrega os estabelecimentos de saúde
     */
    async carregarEstabelecimentos() {
      try {
        this.loadingEstabelecimentos = true
        let response = await this.$api.get(
          `/app/bpa-c/${this.$store.state.cod_ibge}/unidades-de-saude`
        )
        if (response) {
          this.estabelecimentos = response.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingEstabelecimentos = false
      }
    },

    /**
     * Busca os dados
     */
    async buscar() {
      try {
        const isValid = await this.$refs.form.validate()
        if (!isValid) {
          return false
        }

        this.loading = true
        const response = await Functions.getDados(
          this.$store.state.cod_ibge,
          this.form.co_ubs.co_ubs,
          this.form.mes.value,
          this.form.ano,
          this.form.tipo
        )
        if (response) {
          this.cadastros = []
          this.cadastrosOriginais = response
          this.cadastros = response
          this.totalItems = response.length
          this.loading = false
        }
      } catch (error) {
        console.log(error)
        this.loading = false
      } finally {
        this.loading = false
      }

      return
    },

    /**
     * Gera o relatório em PDF.
     */
    generatePdf() {
      Functions.generatePdf(
        this.displayedCadastros,
        this.form.co_ubs.no_unidade_saude,
        this.form.mes.value,
        this.form.ano
      )
    },
  },
  async created() {
    await this.carregarEstabelecimentos()
  },
}
</script>

<style></style>
